/*
 * Author: Chao.Wang
 * File Created: Friday, 25-04-18 04:11 pm
 * Last Modified: Monday, 25-04-21 03:01 pm, by Chao.Wang
 */

import { graphql } from '@web/graphql';
import { getEnv } from '@web/utils';

import type { ErrorCodes, ErrorDetail, ErrorDetailResp } from './@type';
import { DEFAULT_LOCALE } from './manager';

export const queryInfraErrorCodes = graphql.gql`
query InfraErrorCodeItems($sort: [String], $locale: I18NLocaleCode, $status: PublicationStatus, $pagination: PaginationArg,$filters: InfraErrorCodeItemFiltersInput) {
  infraErrorCodeItems(sort: $sort, locale: $locale, status: $status, pagination: $pagination,filters: $filters) {
    updatedAt
    publishedAt
    scope {
      name
    }
    msg
    locale
    header
    disabled
    code
    btn2
    btn1
    action
  }
}
`;

export const queryInfraErrorCodesByScope = async (
  locale: DEFAULT_LOCALE,
  scope: string[]
) => {
  const env = getEnv();
  const isProd = env === 'prod';

  const targetKey = isProd ? 'publishedAt' : 'updatedAt';

  const { data } = await graphql.query<{
    infraErrorCodeItems?: (ErrorDetailResp & { __typename: string })[];
  }>(queryInfraErrorCodes, {
    force: true,
    variables: {
      locale,
      sort: [`${targetKey}:desc`],
      pagination: {
        start: 0,
        limit: -1,
      },
      filters: {
        or: scope?.map((item) => {
          return {
            scope: {
              name: {
                eq: item,
              },
            },
          };
        }),
      },
    },
  });

  const errorCodes = scope.reduce((acc, currScope) => {
    // 获取当前 scope 对应的数据
    const scopeData =
      data.infraErrorCodeItems?.filter(
        (item) => item.scope?.name === currScope
      ) || [];

    scopeData.forEach((item) => {
      const { scope: itemScope, code, ...rest } = item; // 获取 scope 和 code，其他内容用 rest 收集
      const scopeName = itemScope?.name; // 获取 scope 的 name

      if (scopeName) {
        // 如果该 scope 不存在，初始化为空对象
        if (!acc[code]) {
          acc[code] = {} as ErrorDetail; // 初始化对应的 code
        }

        // 合并数据，确保后面的 scope 覆盖前面的
        acc[code] = {
          ...acc[code], // 保留之前合并的数据
          ...rest, // 合并当前的数据
          scope: scopeName, // 只保留 scope.name
        };
      }
    });

    return acc;
  }, {} as ErrorCodes);
  return errorCodes || {};
};
